import enBase from './languages/en'
// import fa from './languages/fa'
// import ar from './languages/ar'

export default {
  enBase

  /*fa,

  ar*/
}
